export default "/images/0e51cc93b7536baa8794633b5b039e81.avif";